import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { profileLayoutDesktopFrameStyles } from '@/features/Profile/core/ProfileLayout/ProfileLayout.styled';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Grid = styled.div<{ $isCount?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isCount }) =>
      $isCount &&
      css`
        max-width: 470px;
      `}

    ${({ $isCount }) =>
      !$isCount &&
      css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
      `}
  }
`;

export const TopUpButton = styled(Button).attrs({
  appearance: 'secondaryLight',
  borderRadius: 10,
})`
  height: 40px;
  padding: 0 20px;
  font-size: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 50px;
    border-radius: 14px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
  }
`;

export const Block = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 20px 15px;
    border-radius: 21px 21px 0 0;

    &:first-child {
      padding-top: 0;
      border-radius: 0;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -5px 0 -6px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 5px 0 0;
  }
`;

export const Title = styled(Typography.Header).attrs({ $variant: '3' })<{
  $isCount?: boolean;
}>`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isCount }) =>
      $isCount &&
      css`
        display: flex;
        align-items: center;
        height: 30px;
      `}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 24px;
    font-weight: 700;
  }
`;
